"use client";

import { useTranslations } from "next-intl";
import { Button, Typography } from "@artha/ui";
import { PERSONALIZATION_FIELD_CLASS_NAME } from "../../personalization.utils";

type SignInStepProps = {
  email: string;
  isRequestingCode: boolean;
  onEmailChange: (email: string) => void;
  onSubmit: () => void;
};

export function SignInStep({
  email,
  isRequestingCode,
  onEmailChange,
  onSubmit,
}: SignInStepProps) {
  const t = useTranslations("profile.resumePersonalization");

  return (
    <form
      className="space-y-4"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <div>
        <Typography as="h2" variant="large" className="font-bold text-black">
          {t("signIn.title")}
        </Typography>
        <p className="mt-2 text-sm text-[#667085]">
          {t("signIn.description")}
        </p>
      </div>
      <label className="block space-y-1.5">
        <span className="text-sm font-semibold text-[#344054]">
          {t("review.email")}
          <span className="text-[#9D1C1C] ml-0.5">*</span>
        </span>
        <input
          type="email"
          autoComplete="email"
          aria-label={t("review.email")}
          value={email}
          className={PERSONALIZATION_FIELD_CLASS_NAME}
          onChange={(event) => onEmailChange(event.target.value)}
        />
      </label>
      <Button
        type="submit"
        className="h-12 w-full rounded-[10px] bg-primary font-bold text-primary-foreground"
        disabled={isRequestingCode}
      >
        {isRequestingCode
          ? t("actions.sendingCode")
          : t("actions.sendCode")}
      </Button>
    </form>
  );
}
